import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import 'bs-stepper/dist/css/bs-stepper.min.css'

Vue.use(Vuetify);

export default new Vuetify();
